import AdminBotLogDetail from "./AdminBot";
export default AdminBotLogDetail;
